<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    class="h-100"
  >
    <MgmFrontFrame>
      <MethodsAndTerms v-if="showTerms" />
      <template v-else-if="!hasCodeAndMemberId()">
        <!-- 文案 begin -->
        <h5
          :style="`color: rgba(${MgmData.themeColor}, 1.0);`"
          class="text-center"
          v-html="title"
        />
        <div
          v-if="showSubImg"
          class="mx-auto"
          style="max-width: 150px"
        >
          <img
            :src="MgmData.themeSubImg"
            alt=""
            class="w-100"
            @error="showSubImg = false"
          >
        </div>
        <div class="text-left mb-4">
          <article v-html="MgmData.introductionDesc" />
        </div>
        <!-- 文案 end -->
        <!-- SSO begin -->
        <div>
          <b-button
            class="w-100 mx-auto d-block d-lg-inline-block"
            :style="`background: rgba(${MgmData.themeColor}, 1.0); border-color: rgba(${MgmData.themeColor}, 1.0)`"
            @click="checkAccountID"
          >
            {{ $t("global.mgm-bind-now") }}
          </b-button>
        </div>
        <!-- SSO end -->
      </template>
      <MgmInvitedFinish
        v-else
        :title="title"
        :mgm-data="MgmData"
        :go-to-member-center-with-code="goToMemberCenterWithCode"
      />
    </MgmFrontFrame>
    <Popup
      v-if="showPopup"
      :have-cancel="false"
      :have-close="false"
      :confirm-wording="$t('global.goToMemberCenter')"
      @cancel="goToMemberCenter"
      @close="goToMemberCenter"
      @confirm="goToMemberCenter"
    >
      <h5 class="alert-heading">
        {{ $t("global.isMember") }}
      </h5>
      <p class="text-break-word font-size-md">
        {{ $t("global.isMember-content") }}
      </p>
    </Popup>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import MgmFrontFrame from '@/components/Mgm/MgmFrontFrame.vue';
import MethodsAndTerms from '@/components/Mgm/MethodsAndTerms.vue';
import MgmInvitedFinish from '@/components/Mgm/MgmInvitedFinish.vue';
import Popup from '@/components/Popup.vue';
import store from '@/store/index';
import i18n from '@/locales/i18n';

export default {
  components: {
    MgmFrontFrame,
    Popup,
    MethodsAndTerms,
    MgmInvitedFinish,
  },
  data() {
    return {
      limitedAgainSendTime: '',
      errorMessage: '',
      EndTime: '',
      name: '',
      showPopup: false,
      showSubImg: true,
      userId: '',
    };
  },
  computed: {
    ...mapState(['MgmData', 'companyId', 'showTerms', 'memberSourceId', 'activityId', 'memberId']),
    title() {
      return this.MgmData.inviteTitle.replace(/{inviteName}/gi, this.name);
    },
  },
  created() {
    const noAccessAddFriend = this.$route.query.friendship_status_changed !== undefined
      && this.$route.query.friendship_status_changed.toLowerCase() === 'false';

    if (
      this.$route.query.code
      && this.$route.query.state
      && !noAccessAddFriend
    ) {
      const { params } = this.$route;
      params.page = 'MgmInvitedSSO';
      const queryString = new URLSearchParams(this.$route.params).toString();
      const isLocal = process.env.VUE_APP_IS_LOCAL !== undefined
        && process.env.VUE_APP_IS_LOCAL.toLowerCase() === 'true';
      const origin = window.location.origin + (isLocal ? '' : '/activity');
      const href = `${origin}/LINELoginJumpPage`;
      const redirectUrl = `${href}?${queryString}`;
      const body = {
        code: this.$route.query.code,
        directURL: redirectUrl,
      };

      this.postLINEUserId(body).then((res) => {
        if (res.success) {
          this.userId = res.data.userID;
        } else {
          this.getLINEOpenId();
        }
      });
    } else {
      this.getLINEOpenId();
    }
    this.getCustomer().then((res) => {
      if (res && res.response.success) {
        this.name = res.response.data[0].name;
      }
    });
    this.getMobileVerifySetting('LimitedAgainSendTime').then((res) => {
      if (res && res.response.success) {
        this.limitedAgainSendTime = res.response.data[0].value;
      }
    });
    this.postWording();

    // 判斷活動是否開始
    const now = Date.now();
    let status = 2;
    if (this.MgmData.startTime > now) {
      this.set({ name: 'showTerms', value: true });
      this.set({ name: 'termsType', value: 'beforestart' });
      status = 1;
    }
    if (this.MgmData.endTime < now || (this.MgmData.active === false && this.MgmData.status === 'submitted')) {
      this.set({ name: 'showTerms', value: true });
      this.set({ name: 'termsType', value: 'afterend' });
      status = 3;
    }
    this.$store.dispatch('postMGMLog', status);
  },
  beforeRouteEnter(to, from, next) {
    store.commit('set', { name: 'memberId', value: to.params.memberId });
    store.commit('set', { name: 'activityId', value: to.params.activityId });
    store.commit('set', { name: 'companyId', value: to.params.companyId });
    store.commit('set', {
      name: 'memberSourceId',
      value: to.params.memberSourceId,
    });
    // 取得活動資料
    store
      .dispatch('getMGMData')
      .then(() => {
        next();
      })
      .catch(() => {
        next({
          name: 'Error',
          params: { content: i18n.t('error.activity-not-found') },
        });
      });
  },
  methods: {
    ...mapActions('mbc', [
      'getAccountVerifier',
      'getCustomer',
      'getMemberAccount',
      'postLINEUserId',
    ]),
    ...mapActions('sso', [
      'getMobileVerifySetting',
      'postWording',
      'postLogin',
    ]),
    ...mapMutations(['set', 'setShowTerms']),
    goToMemberCenter() {
      this.showPopup = false;
      window.location.href = `${window.location.origin}/rewards/membercenter?companyid=${this.companyId}&membersourceid=${this.memberSourceId}`;
    },
    goToMemberCenterWithCode() {
      const code = sessionStorage.getItem('code');
      sessionStorage.removeItem('code');
      sessionStorage.removeItem('memberId');
      sessionStorage.removeItem('identifySource');

      const params = {
        companyid: this.companyId,
        membersourceid: this.memberSourceId,
        code,
      };
      const queryString = new URLSearchParams(params).toString();
      const href = `${window.location.origin}/rewards/membercenter/personalinfo?${queryString}`;

      window.location.href = href;
    },
    // 檢查是否綁定過
    checkAccountID() {
      this.getAccountVerifier(this.userId).then((res) => {
        if (res && res.response.success) {
          // 沒有綁定過就導頁南山SSO
          const ssoUrl = JSON.parse(process.env.VUE_APP_USE_ENV)
            ? '${VUE_APP_VUE_SSO_URL}'
            : process.env.VUE_APP_VUE_SSO_URL;
          const queryString = new URLSearchParams({
            companyid: store.state.companyId,
            membersourceid: store.state.memberSourceId,
            teactid: this.activityId,
            temid: this.memberId,
            teopid: this.userId,
          }).toString();

          let ssoLoginUrl = `${ssoUrl}login?${queryString}`;
          // 取得membersourcesetting
          this.$store.dispatch('sso/getMemberSourceSetting').then((r) => {
            const redirectParam = r.data[0].setttingDetl.find((s) => s.paramType.toLowerCase() === 'act' && s.paramCode.toLowerCase() === 'ssoredirecturl');
            if (redirectParam) {
              const ssoredirecturl = encodeURIComponent(redirectParam.paramValue);
              ssoLoginUrl = `${ssoUrl}login?${queryString}&linebind=1&redirect_url=${ssoredirecturl}`;
            }
            window.location.href = `${ssoLoginUrl}`;
          }).catch(() => {
            window.location.href = `${ssoLoginUrl}`;
          });
        } else {
          this.showPopup = true;
        }
      });
    },
    hasCodeAndMemberId() {
      const code = sessionStorage.getItem('code');
      const hasCode = code && code.length > 0;
      const memberId = sessionStorage.getItem('memberId');
      const hasMemberId = code && memberId.length > 0;

      return hasCode && hasMemberId;
    },
    // 登入 line
    getLINEOpenId() {
      const { params } = this.$route;
      params.page = 'MgmInvitedSSO';
      const queryString = new URLSearchParams(this.$route.params).toString();
      const isLocal = process.env.VUE_APP_IS_LOCAL !== undefined
        && process.env.VUE_APP_IS_LOCAL.toLowerCase() === 'true';
      const origin = window.location.origin + (isLocal ? '' : '/activity');
      const href = `${origin}/LINELoginJumpPage`;
      const redirectUrl = encodeURIComponent(`${href}?${queryString}`);
      const comUrl = JSON.parse(process.env.VUE_APP_USE_ENV)
        ? '${VUE_APP_API_COM_URL}'
        : process.env.VUE_APP_API_COM_URL;
      const lineLoginUrl = `${comUrl}api/v1/linecode?DirectUrl=${redirectUrl}&CompanyId=${this.companyId}&MemberSourceId=${this.memberSourceId}`;

      window.location.href = lineLoginUrl;
    },
  },
};
</script>
